import { Check } from 'lucide-react'

// Static decorative card for the "keep your platform" CTA on the for-nonprofits page:
// a 2x2 grid of competitor platform logos plus a highlighted Gala Season Ticketing row.
const PLATFORMS = [
  { name: 'Givebutter', src: '/logos/givebutter.svg' },
  { name: 'Give Lively', src: '/logos/give-lively.svg' },
  { name: 'GoFundMe', src: '/logos/gofundme.svg' },
  { name: 'Classy', src: '/logos/classy.svg' },
]

export default function PlatformSwitchPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-black/10 bg-card shadow-xs">
      <div className="border-b border-black/5 bg-muted/30 px-5 py-3">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          Works with all other platforms
        </p>
      </div>

      <div className="space-y-3 p-5">
        <div className="grid grid-cols-2 gap-3">
          {PLATFORMS.map((p) => (
            <div
              key={p.name}
              className="flex items-center justify-center rounded-xl bg-muted/40 p-4 ring-1 ring-black/5"
            >
              <img src={p.src} alt={p.name} className="h-6 w-auto opacity-80" />
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-3 rounded-xl bg-primary/10 p-4 ring-1 ring-primary/20">
          <img src="/favicon.svg" alt="" className="size-7 shrink-0" />
          <span className="min-w-0 flex-1 text-sm font-semibold leading-tight text-primary sm:text-base">Gala Season Ticketing</span>
          <span className="ml-10 inline-flex shrink-0 items-center gap-1 rounded-full bg-primary px-2.5 py-0.5 text-xs font-semibold text-primary-foreground sm:ml-auto">
            <Check className="size-3" />
            Free
          </span>
        </div>
      </div>
    </div>
  )
}
